import { Fragment } from 'react'
import styles from './StepIndicator.module.css'

export interface Step {
  label: string
}

export interface StepIndicatorProps {
  steps: Step[]
  current: number // 0-based index
}

export function StepIndicator({ steps, current }: StepIndicatorProps) {
  return (
    <div className={styles.root} role="list" aria-label="Schritte">
      {steps.map((step, i) => (
        <Fragment key={i}>
          {i > 0 && (
            <div
              className={[styles.connector, i <= current ? styles.connectorDone : '']
                .filter(Boolean)
                .join(' ')}
            />
          )}
          <div
            role="listitem"
            aria-current={i === current ? 'step' : undefined}
            className={[
              styles.step,
              i < current ? styles.done : '',
              i === current ? styles.active : '',
            ]
              .filter(Boolean)
              .join(' ')}
          >
            <div className={styles.circle}>{i < current ? '✓' : String(i + 1)}</div>
            <span className={styles.label}>{step.label}</span>
          </div>
        </Fragment>
      ))}
    </div>
  )
}
